import React from "react";
import content from "../../content.json";
import { logo } from "../../assets/index";

const AboutUs = () => {
  return (
    <div className="h-full dark:bg-[#292930] -z-30 -mt-44 pb-28 pt-28 block">
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-38.png"
        alt=""
        className="absolute dark:opacity-10  -z-20 right-16"
      />
      <img
        src="https://cdn.discordapp.com/attachments/859118146086764578/1134725803234557994/image-removebg-preview_4.png"
        alt=""
        className="absolute dark:opacity-30 opacity-0 w-[400px] z-10 right-16"
      />
      <img
        src="https://cdn.discordapp.com/attachments/859118146086764578/1134725803234557994/image-removebg-preview_4.png"
        alt=""
        className="absolute dark:opacity-20 opacity-0 w-[1000px] z-10 -ml-[400px] -mt-32"
      />
      <img
        src="https://cdn.discordapp.com/attachments/859118146086764578/1134728133610852392/image-removebg-preview_5.png"
        alt=""
        className="absolute dark:opacity-100 opacity-0 z-10 mt-40"
      />
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/line-4.png"
        alt=""
        className="absolute dark:opacity-30 z-[-10] mt-36"
      />
      <div className="flex items-center justify-center">
        <h1 className="text-5xl dark:text-[#d3d3d4] font-bold font-dmsans">
          About Us
        </h1>
      </div>
      <div className="flex items-center mx-auto max-w-7xl px-6 lg:px-32 h-400">
        <div className="flex items-center">
          <div className=" h-200 w-500 mr-20 overflow-hidden mt-10 rounded-3xl ">
            <img src={logo} className="w-full h-full" alt="" />
          </div>
          <div className="flex flex-col">
            <h1 className="mt-5 mb-2 text-lg  dark:text-[#d3d3d4] w-full group-hover:text-[#5956e9]   transition text-black">
              {content.aboutus.interface.p}
            </h1>
            <h1 className="text-lg mb-2 w-full dark:text-[#d3d3d4] group-hover:text-[#5956e9]   transition text-black">
              {content.aboutus.interface.p1}
            </h1>
            <h1 className="text-lg w-full dark:text-[#d3d3d4] group-hover:text-[#5956e9]   transition text-black">
              {content.aboutus.interface.p2}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
